<cs-header>
  <cs-header-title large>
    {{ LL.navigation.settings() }}
  </cs-header-title>
</cs-header>

<cs-content>
  @if (isIntakePending()) {
    <div class="intake-pending-card-wrapper">
      <cs-info-card type="info" [dismissible]="false">
        <div class="intake-pending-card-title">
          <strong>{{ LL.settings.intakePendingCard.title() }}</strong>
        </div>
        <div>
          {{ LL.settings.intakePendingCard.body() }}
          <button class="link" (click)="navigateToIntake()">{{ LL.settings.intakePendingCard.linkText() }}</button>
        </div>
      </cs-info-card>
    </div>
  }
  <div class="settings-grid-container">
    <div class="settings-column">
      @for (section of getLeftColumnSections(); track section.id) {
        <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: section }"></ng-container>
      }
    </div>

    <div class="settings-column">
      @for (section of getRightColumnSections(); track section.id) {
        <ng-container *ngTemplateOutlet="sectionCard; context: { $implicit: section }"></ng-container>
      }
    </div>
  </div>

  <!-- One Settings section card, drawn the same way for whichever column it
       landed in. Both columns render this template, so a change to how a row
       looks is made once and cannot leave the two columns disagreeing.
       ng-container puts nothing of its own in the page, so each cs-card is
       still a direct child of .settings-column and the column's flex gap
       still applies between the cards. -->
  <ng-template #sectionCard let-section>
    <cs-card class="settings-card" [id]="section.id">
      <cs-card-title>{{ section.title }}</cs-card-title>
      <cs-card-content>
        <cs-item-list>
          @for (item of section.items; track item.label) {
            <cs-item [class.disabled]="!isItemEnabled(section, item)"
              (click)="handleItemClick(section, item)" [style.display]="isItemVisible(item) ? 'flex' : 'none'">
              @if (item.imageUrl) {
                <img class="settings-item-logo" item-left [src]="item.imageUrl" alt="" />
              } @else {
                <cs-icon [name]="item.icon" item-left></cs-icon>
              }
              <cs-label item-content>{{ item.label }}</cs-label>
              <cs-icon name="arrow-dropright" item-right></cs-icon>
              <button cs-capture-cover></button>
            </cs-item>
          }
        </cs-item-list>
      </cs-card-content>
    </cs-card>
  </ng-template>

  <!-- Version info - add padding to account for install button if present -->
  <div class="settings-footer" [class.with-install-button]="shouldShowInstallButton()">
    <div class="version-info" (click)="handleVersionClicked()">{{ appVersion }}</div>
  </div>
</cs-content>

<!-- Page-action buttons: install affordance and / or "Check for
     updates". cs-page-action-buttons is position: fixed; bottom: 0,
     so the two cs-button entries MUST share a single wrapper —
     otherwise on a desktop PWA where both gates pass, two floating
     bars would stack on the same position and the second would
     occlude the first. See design-docs/in-app-update-prompt.md
     §Settings entry. -->
@if (shouldShowInstallButton() || shouldShowCheckForUpdatesButton()) {
  <cs-page-action-buttons>
    @if (shouldShowInstallButton()) {
      <cs-button medium secondary [label]="LL.settings.installApp()" [icon]="'download'" (click)="installApp()"></cs-button>
    }
    @if (shouldShowCheckForUpdatesButton()) {
      <cs-button medium secondary [label]="LL.app.updateAvailable.settingsRow()" [icon]="'refresh'" (click)="checkForUpdatesAsync()"></cs-button>
    }
  </cs-page-action-buttons>
}
